import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  regGeneralInformation: 'Location',
  regCompanyInformation: 'Company Information',
  regCompanyTitle: 'Details of the legal representative of your company',
  regTerms: 'Confirm',
  regTermsInformation: 'Almost there! Please confirm the terms and conditions',
  regTransactionalProfile: 'Transactional Profile',
  regTermsConfirmation1:
    'By registering on our platform, you confirm that you have read and understood all our ',
  regTermsConfirmation2: 'terms and conditions',
  regTermsConfirmation3: ' available on our',
  regTermsConfirmation4: 'legal page',
  regTermsConfirmation5: ', which include EFEX terms of service.',
  regTermsConfirmationDisclaimer:
    'EFEX is a Financial Technology Company and not a bank. The deposit account is issued by banking partners.',
  regLogin: 'Login',
  regSuccessMessage:
    'Registration successful! Please login with your credentials.',
  regFailureMessage: 'Registration failed. Please try again.',
  regFirstName: 'Name(s)',
  regLastName: 'Last name',
  regSecondLastName: 'Second last name',
  regSecondLastNameCheckbox: "I don't have a second last name",
  regNameMessage:
    'Name of the authorized representative who establishes the opening of the account.',
  regRepresentative:
    'Title of the authorized representative establishing the banking relationship',
  regEmail: 'Corporate email',
  regPhone: 'Phone',
  regWAPhone: 'Contact telephone number',
  companyInformationTitle: "Legal representative's information",
  regPassword: 'Password',
  regPasswordTitle: 'Create a password',
  regCompanyName: 'Legal company name',
  regCompanyNameHelper:
    'Verify that it is the same as the one on your articles of incorporation.',
  regFirstNameValidation: 'The First name field is required',
  regLastNameValidation: 'The last name field is required',
  regregSecondLastNameValidation: 'The second last name field is required',
  regCompanyNameValidation: 'The company name field is required',
  regConfirmPassword: 'Confirm password',
  regEmailValidation: 'The email field is required',
  regPhoneValidation: 'The phone field is required',
  regPhoneIsNotValid: 'The phone number is not valid',
  regPasswordValidation: 'The Password field is required',
  regConfirmPasswordValidation: 'The Passwords do not match',
  regBackBtn: 'Back',
  regContinue: 'Continue',
  capitalLetter: 'Must include at least one capital letter',
  lowercaseLetter: 'Must include at least one lowercase letter',
  containNumbers: 'Must include at least one number',
  lengthValid: 'Must have a minimum length of 7 letters',
  maxLength: 'Must have a maximum length of 40 characters',
  specialCharacters: 'Must include at least one special character (!@#$%&*)',
  noWhitespace: 'Must not include any whitespace',
  pleaseAcceptTerms: 'You must accept the terms and conditions to continue',
  userAcceptTerms: 'I accept the terms and conditions',
  emailNonValid: 'The email is already registered, try again',
  userConfirmEdition: 'Is the data entered correct?',
  pleaseAcceptEdition:
    'You must accept that the data to be modified is correct',
  entityMessage: 'From which country are you opening your account?',
  regWelcome: 'Welcome to ',
  regWelcomeMessage:
    'Open your global business account quickly and easily. Make sure you have the following documents on hand to start the process:',
  regBusinessTitle: 'Business:',
  regBusinessMessage1: 'Incorporation Document.',
  regBusinessMessage2: 'Bank Statement',
  regBusinessMessage3: 'Proof of address',
  infoStakeholders: 'Add shareholders with a stake of 25% or more',
  regBusinessMessage4: 'ID of stakeholders with more than 25% of shares.',
  regConfirmCheckBox:
    'I certify that the information provided above is correct',
  regResourceStatement:
    'Has the shareholder {{name}} {{lastName}} held prominent public functions within the national or foreign territory in the last 12 months?',
  regResourceStatementResponse:
    'Specify the position, institution or department and period',
  regResourceStatementFamily:
    'Does the shareholder {{name}} {{lastName}} have any first- or second-degree relatives who have held prominent public positions within the national or foreign territory in the past 12 months?',
  regResourceStatementFamilyResponse:
    'Specify the position, institution or department and period',
  regLegalRepresentativeStatament:
    'I declare that the resources used are from the company itself and it acts on its own behalf',
  regGender: 'Legal gender',
  regGenderValidation: 'Gender is required',
  regStakeHolderEntityValidation: 'Person type is required',
  regGenderMale: 'Male',
  regGenderFemale: 'Female',
  regStakeholderEntity: 'Stakeholder Entity Type',
  regNaturalPersonMX: 'Mexican natural person',
  regJuridicalPersonMX: 'Mexican legal entity',
  regNaturalPersonForeigner: 'Foreign natural person',
  regJuridicalPersonForeigner: 'Foreign legal entity',
  regNationality: 'Nationality',
  regBirthCountry: 'Country of birth',
  regIncorporationCountry: 'Country of incorporation',
  regFederalEntity: 'Federal entity',
  regCurp: 'CURP',
  regCurpText: "Don't know your CURP?",
  regCurpValidation: 'Please enter a valid CURP',
  regCurpHelper: 'As it appears on your identification (use capital letters)',
  regResourceStatementPerson:
    'Do you have a family relationship by consanguinity or affinity or any patrimonial link with a person who has performed or has performed in the last 12 months outstanding public functions or political activities in the national or foreign territory? If so, please indicate the position, institution or dependency and period',
  regLegalRepresentativePersonStatament:
    'I declare that the resources used are of lawful origin and will be used for lawful purposes',
  regDeposits: 'Payments in',
  regMonthlyVolume: 'Estimated number of transactions every month',
  regMonthlyAmount: 'Estimated volume of transactions every month',
  regMonthlyRecipients:
    'Number of accounts from which you will receive transfers every month',
  regMonthlyRecipientsPays:
    'Estimated number of recipients that you will send transfers every month',
  regFundsSource: 'Source of funds of your business',
  regAccountUsage: 'How do you intend to use your account?',
  regTransactionsAbroad:
    'Apart from domestic transfers, do you send international transactions?',
  regAdGoodsOffered: 'What goods or services does your business offer?',
  regAdBussinesPromotion:
    'How do you promote your business and acquire your customer base?',
  regAdEfexAccountUsage:
    'How will you use the EFEX account for sending and receiving?',
  regNameStartSpace: 'Cannot start with space',
  regNameEndSpace: 'Cannot end with space',
  regNameConsecutiveSpaces: 'Cannot contain consecutive spaces',
  regNameOnlySpaces: 'Cannot contain only spaces',
  subaccountCheck:
    'Check this box if this account will be linked to a master account',
  subaccountCheckMessage:
    '(Optional) If you are a Master Account and you are registering a subaccount, please select this field. Master Accounts are EFEX partners who use our technological infrastructure to offer embedded finance products to their own customers.',
  regMasterAccountName: 'Name of Master Account',
  regMasterAccountNameHelper:
    'This is the name of the Master Account that will be associated with the sub-account.',
  regValidating: 'Validating...',
  regValidOrganization: 'Valid organization',
  regOrganizationNotFound: 'Organization not found',
  regServerError: 'Server error. Please try again later.',
  regInvalidOrganizationId: 'Invalid organization ID',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const REGISTER_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string | object>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    regGeneralInformation: 'Ubicación',
    regCompanyInformation: 'Datos de tu empresa',
    regCompanyTitle: 'Datos del representante legal de tu empresa',
    regTerms: 'Confirmar',
    regTermsInformation: '¡Ya casi! Confirma los términos y condiciones',
    regTransactionalProfile: 'Perfil Transaccional',
    regTermsConfirmation1:
      'Al registrarte en nuestra plataforma, confirmas que has leído y comprendido todos nuestros ',
    regTermsConfirmation2: 'términos y condiciones',
    regTermsConfirmation3: ' en nuestra ',
    regTermsConfirmation4: 'página de legal',
    regTermsConfirmation5: ' que incluyen los Términos de servicio de EFEX.',
    regTermsConfirmationDisclaimer:
      'EFEX es una Empresa de Tecnología Financiera y no un banco. La cuenta de depósito es emitida por bancos aliados.',
    regLogin: 'Ingresar',
    regSuccessMessage:
      'Registro exitoso! Por favor, inicie sesión con sus credenciales.',
    regFailureMessage: 'Registro fallido. Por favor, intente nuevamente.',
    regFirstName: 'Nombre(s)',
    regLastName: 'Apellido paterno',
    regSecondLastName: 'Apellido materno',
    regSecondLastNameCheckbox: 'No tengo apellido materno',
    regNameMessage:
      'Nombre del representante autorizado que establece la apertura de la cuenta.',
    regRepresentative:
      'Cargo del representante autorizado que establece la relación bancaria',
    regEmail: 'Email corporativo',
    regPhone: 'Teléfono',
    regWAPhone: 'Teléfono de contacto',
    regPassword: 'Contraseña',
    companyInformationTitle: 'Información del representante legal',
    regPasswordTitle: 'Crea tu contraseña',
    regConfirmPassword: 'Confirmar contraseña',
    regCompanyName: 'Nombre legal de la empresa',
    regCompanyNameHelper: 'Verifica que sea igual al de tu acta constitutiva',
    regFirstNameValidation: 'El campo Nombre es obligatorio',
    regLastNameValidation: 'El campo apellido paterno es obligatorio',
    regregSecondLastNameValidation: 'El campo apellido materno es obligatorio',
    regCompanyNameValidation: 'El campo nombre de la empresa es obligatorio',
    regEmailValidation: 'El campo de correo electrónico es obligatorio',
    regPhoneValidation: 'El campo de teléfono es obligatorio',
    regPhoneIsNotValid: 'El número de teléfono no es válido',
    regPasswordValidation: 'El campo Contraseña es obligatorio',
    regConfirmPasswordValidation: 'Las contraseñas no coinciden',
    regBackBtn: 'Regresar',
    regContinue: 'Continuar',
    capitalLetter: 'Debe incluir al menos una mayúscula',
    lowercaseLetter: 'Debe incluir al menos una minúscula',
    containNumbers: 'Debe incluir al menos un número',
    lengthValid: 'Debe tener una longitud mínima de 7 letras',
    maxLength: 'Debe tener una longitud máxima de 40 caracteres',
    specialCharacters: 'Debe incluir al menos un carácter especial (!@#$%&*)',
    noWhitespace: 'No debe incluir ningún espacio en blanco',
    pleaseAcceptTerms:
      'Debes aceptar los términos y condiciones para continuar',
    userAcceptTerms: 'Acepto los términos y condiciones',
    emailNonValid: 'El email ya esta registrado, intente nuevamente',
    userConfirmEdition: '¿Los datos ingresados son correctos?',
    pleaseAcceptEdition:
      'Debes aceptar que los datos a modificar son correctos',
    entityMessage: '¿Desde qué país estas abriendo tu cuenta?',
    regWelcome: 'Bienvenido a ',
    regWelcomeMessage:
      'Abre tu cuenta empresarial global de manera ágil y sencilla. Asegúrate de tener a la mano los siguientes documentos para iniciar el proceso:',
    regBusinessTitle: 'Empresa:',
    regBusinessMessage1: 'Documento de Incorporación.',
    regBusinessMessage2: 'Estado de cuenta bancario',
    regBusinessMessage3: 'Comprobante de domicilio',
    infoStakeholders:
      'Agrega a los accionistas con participación mayor o igual al 25%',
    regBusinessMessage4:
      'Identificación de los accionistas con más del 25% de las acciones.',
    regConfirmCheckBox:
      'Certifico que la información proporcionada anteriormente es correcta',
    regResourceStatement:
      '¿El accionista {{name}} {{lastName}} ha desempeñado funciones públicas destacadas dentro del territorio nacional o extranjero en los últimos 12 meses?',
    regResourceStatementResponse:
      'Especificar el cargo, institución o dependencia y periodo',
    regResourceStatementFamily:
      '¿El accionista {{name}} {{lastName}} tiene parientes de primer o segundo grado que han desempeñado funciones públicas destacadas dentro del territorio nacional o extranjero en los últimos 12 meses?',
    regResourceStatementFamilyResponse:
      'Especificar la posición, institución o dependencia y periodo',
    regLegalRepresentativeStatament:
      'Declaro que los recursos utilizados son de la propia empresa y actúa por cuenta propia',
    regGender: 'Género legal',
    regGenderValidation: 'El género es requerido',
    regStakeHolderEntityValidation: 'El tipo de persona es requerido',
    regGenderMale: 'Masculino',
    regGenderFemale: 'Femenino',
    regStakeholderEntity: 'Tipo de persona',
    regNaturalPersonMX: 'Persona física mexicana',
    regJuridicalPersonMX: 'Persona moral mexicana',
    regNaturalPersonForeigner: 'Persona física extranjera',
    regJuridicalPersonForeigner: 'Persona moral extranjera',
    regNationality: 'Nacionalidad',
    regBirthCountry: 'País de nacimiento',
    regIncorporationCountry: 'País de constitución',
    regFederalEntity: 'Entidad federativa',
    regCurp: 'CURP',
    regCurpText: '¿No conoces tu CURP?',
    regCurpValidation: 'Por favor ingrese un CURP válido',
    regCurpHelper: 'Tal como aparece en tu identificación (usa mayúsculas)',
    regResourceStatementPerson:
      'Tiene familiar por consanguinidad o afinidad o algún vinculo patrimonial con alguna persona que desempeñe o haya desempeñado en el transcurso de los últimos 12 meses funciones publicas o actividades políticas destacadas en el territorio nacional o extranjero? En caso de ser afirmativo, por favor indique el cargo, institución o dependencia y periodo',
    regLegalRepresentativePersonStatament:
      'Manifiesto que los recursos utilizados son de procedencia licita y serán destinados a fines lícitos',
    regDeposits: 'Ingresos',
    regMonthlyVolume: 'Número de transacciones estimadas por mes',
    regMonthlyAmount: 'Volumen de operaciones estimadas por mes',
    regMonthlyRecipients:
      'Número de cuentas desde las cuales vas a recibir transferencias cada mes',
    regMonthlyRecipientsPays:
      'Número estimado de destinatarios a los cuales les vas a enviar transferencias cada mes',
    regFundsSource: 'Fuente de fondos de su negocio',
    regAccountUsage: '¿Cómo pretende utilizar su cuenta?',
    regTransactionsAbroad:
      '¿Mensualmente envía transferencias internacionales?',
    regAdGoodsOffered: '¿Qué bienes o servicios ofrece su empresa?',
    regAdBussinesPromotion:
      '¿Cómo promociona su negocio y gana su base de clientes?',
    regAdEfexAccountUsage: '¿Cómo usará la cuenta EFEX para enviar y recibir?',
    regNameStartSpace: 'No puede comenzar con espacio',
    regNameEndSpace: 'No puede terminar con espacio',
    regNameConsecutiveSpaces: 'No puede contener espacios consecutivos',
    regNameOnlySpaces: 'No puede contener solo espacios',
    subaccountCheck:
      'Marca esta casilla si esta cuenta estará asociada a una cuenta principal',
    subaccountCheckMessage:
      '(Opcional) Si eres un Master Account y estás dando de alta el registro de una subcuenta, por favor selecciona este campo. Los Master Account son aliados de EFEX que utilizan nuestra infraestructura tecnológica para ofrecerle productos de finanzas embebidas a sus propios clientes.',
    regMasterAccountName: 'Nombre del Master Account',
    regMasterAccountNameHelper:
      'Este es el nombre del Master Account que estará asociado a la subcuenta',
    regValidating: 'Validando...',
    regValidOrganization: 'Organización válida',
    regOrganizationNotFound: 'Organización no encontrada',
    regServerError: 'Error del servidor. Por favor, inténtelo más tarde.',
    regInvalidOrganizationId: 'ID de organización no válido',
  },
};

export default REGISTER_LANGUAGE_LABELS;
